import React from 'react';
import strings from 'owa-strings/owa-mini-common-strings';
import { GenericErrorScreen } from 'mini-error-handler';
import { getActiveResultsTab } from 'mini-3s-search-store/lib/selectors/getActiveResultsTab';
import { getPackageBaseUrl } from 'owa-config';
import { observer } from 'mobx-react-lite';
import { SearchResultsTab } from 'mini-3s-search-store/lib/store/schema/SearchResultsTab';
import { setCurrentQuery } from 'mini-suggestions-actions/lib/actions/publicActions';
import { urlResolve } from 'mini-common-utils/lib/utils/urlResolve';
import { useChangeRoute } from 'route-state-utils/lib/hooks/useChangeRoute';
import { useTheme } from 'mini-theme/lib/contexts/ThemeContext';

export interface SearchResultsEmptyScreenProps {
    allowRetry?: boolean;
}
const styles = require('./SearchResultsEmptyScreen.scss');

const EMPTY_MAIL_LIST_IMAGE = 'resources/images/emptyListGeneric.svg';
const EMPTY_EVENT_LIST_IMAGE = 'resources/images/emptyCalendar.svg';
const EMPTY_CONTACT_LIST_IMAGE = 'resources/images/emptyContactList.svg';

const EMPTY_MAIL_LIST_DARK_IMAGE = 'resources/images/emptyListGenericDark.svg';
const EMPTY_EVENT_LIST_DARK_IMAGE = 'resources/images/emptyCalendarDark.svg';
const EMPTY_CONTACT_LIST_DARK_IMAGE = 'resources/images/emptyContactListDark.svg';

const SearchResultsEmptyScreenBase = (props: SearchResultsEmptyScreenProps) => {
    const { allowRetry = true } = props;
    const { goBack } = useChangeRoute();
    const { isDarkTheme } = useTheme();

    const retryHandler = () => {
        setCurrentQuery('');
        goBack();
    };
    let titleText: string = '';
    let imageSrc: string = '';
    const currentTabName = getActiveResultsTab();

    switch (currentTabName) {
        case SearchResultsTab.Mail:
            titleText = strings.noEmailResultsTitle;
            imageSrc = isDarkTheme ? EMPTY_MAIL_LIST_DARK_IMAGE : EMPTY_MAIL_LIST_IMAGE;
            break;
        case SearchResultsTab.Events:
            titleText = strings.noEventResultsTitle;
            imageSrc = isDarkTheme ? EMPTY_EVENT_LIST_DARK_IMAGE : EMPTY_EVENT_LIST_IMAGE;
            break;
        case SearchResultsTab.People:
            titleText = strings.noContactResultsTitle;
            imageSrc = isDarkTheme ? EMPTY_CONTACT_LIST_DARK_IMAGE : EMPTY_CONTACT_LIST_IMAGE;
            break;
    }

    const image = (
        <img
            src={urlResolve(getPackageBaseUrl(), imageSrc)}
            aria-hidden
            alt=""
            role="presentation"
        />
    );
    const title = { text: titleText };
    const subtitle = { text: strings.noResultsMessage };
    const actionButton = { label: strings.noResultsRetryButton, onClick: retryHandler };

    return (
        <GenericErrorScreen
            containerClassName={styles.errorContainer}
            image={image}
            title={title}
            subtitle={subtitle}
            actionButton={allowRetry && actionButton}
        />
    );
};

export const SearchResultsEmptyScreen = observer(SearchResultsEmptyScreenBase);
